import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoOperadoras from './components/ListadoOperadoras';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allOperadorasAction,
  setActivoOperadorasAction,
} from './OperadorasAction';
import FormOperadoras from './components/FormOperadoras';
import { SnackbarAlertWidget } from '../../../widgets';
import { Paper } from '@mui/material';

const OperadorasView = () => {
  const dispatch = Redux.useDispatch();

  const operadorasStore = Redux.useSelector((state) => state.operadoras);

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={operadorasStore.alertView} />
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoOperadorasAction(dispatch, null);
            await allOperadorasAction(dispatch, operadorasStore.params);
          }}
          disabled={
            operadorasStore.all.length === 0 || operadorasStore.loadingAll
          }
          white
          refreshIcon
          text={operadorasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={4}>
        <Paper elevation={5} sx={{ pb: 1 }}>
          <FormOperadoras />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoOperadoras />
      </Grid>
    </Grid>
  );
};

export default OperadorasView;
